module.exports = __webpack_public_path__ + "static/assets/b9f7b5d4c15fb8bdc78d1ed5b4993a23.png";